import { render, staticRenderFns } from "./FinancialsSettingsComponent.vue?vue&type=template&id=fc34c97c&scoped=true&"
import script from "./FinancialsSettingsComponent.vue?vue&type=script&lang=js&"
export * from "./FinancialsSettingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./FinancialsSettingsComponent.vue?vue&type=style&index=0&id=fc34c97c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc34c97c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VSimpleTable})
